import { HTMLExtUtils } from '@ssml-editor/core';
import { SAY_AS_TYPE } from './constant.js';
import { SayAsInterpretation } from './say-as-interpretation.enum.js';

const sayAsHtmlToElement = ({
  element,
  children
}) => {
  const mark = HTMLExtUtils.getDataAttribute(element, "mark", "");
  const interpretAs = SayAsInterpretation.fromString(
    HTMLExtUtils.getDataAttribute(element, "interpret-as", "id")
  ) || SayAsInterpretation.ID;
  return {
    type: SAY_AS_TYPE,
    mark,
    interpretAs,
    children
  };
};

export { sayAsHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
